import React, {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { Link } from 'react-router-dom';

import {
  Breadcrumb, Row, Col, Card, Input, Button, Select, Space, Spin, DatePicker,
} from 'antd';
import { useTranslation } from 'react-i18next';
import MainLayout from '@common/layouts/MainLayout';
import { ResponsiveContainer } from 'recharts';

import {
  PlusOutlined, StepForwardOutlined, UserOutlined, FilterOutlined, FilterFilled, SearchOutlined,
} from '@ant-design/icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip, faSearch } from '@fortawesome/free-solid-svg-icons';
import DeviceData from './containers/DeviceData/DeviceData';
import ConsultGraphArea from './containers/ConsultGraph/ConsultGraph';
import ConsultGraphLine from './containers/ConsultGraphLine/ConsultGraph';
import ConsultGraphColumn from './containers/ConsultGraphColumn/ConsultGraph';
import ConsultGraphColumnGrouped from './containers/ConsultGraphColumnGrouped/ConsultGraph';
import ConsultGraphColumnDiff from './containers/ConsultGraphColumnDiff/ConsultGraph';

import useGraficasDispositivoVariable from './useGraficasDispositivoVariable';
import useConsultGraph from './containers/ConsultGraph/useConsultGraph';
import MapForVehicles from './containers/MapForVehicle';
import styles from './GraficasDispositivoVariable.module.less';

const { RangePicker } = DatePicker;

function GraficasDispositivoVariable() {

  const { t } = useTranslation();
  const {
    device,
    dataDevice,
    deviceBusinessType,
    BreadcrumbTitle,
    handleDeviceHome,

    loading,
    deviceType,deviceField,setDeviceField,
    datePicker, modePicker, modePickerFormat, setDatePicker,
    granularityNew,defaultGranularity,changeModePicker,
    optionVariableField,variableField,setVariableField
   } = useGraficasDispositivoVariable();
  const { Option, OptGroup } = Select; 
 
  return (
    <>
      <MainLayout applyWidthLimit>
        <Row gutter={[16, 8]}>
          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div style={{
              minHeight: '270px', height: 'fit-content',
            }}
            >
              <Card className="shadows" style={{ width: '100%' }}>
                <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                  <Col
                    xs={{
                      span: 5,
                    }}
                    sm={{
                      span: 4,
                    }}
                    md={{
                      span: 3,
                    }}
                    lg={{
                      span: 2,
                    }}
                    xl={{
                      span: 2,
                    }}
                    className="text-center"
                    style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}
                  >
                    <div className={styles.circle_icon_container}>
                      {dataDevice?.business_type?.logo_full_url && dataDevice?.business_type?.logo_full_url !== ''
                        ? (
                          <img
                            src={dataDevice?.business_type?.logo_full_url}
                            alt={dataDevice?.business_type?.name}
                            className="image-logo-busines-detail"
                          />
                        )
                        : (
                          <FontAwesomeIcon icon={faMicrochip} style={{ fontSize: 20, color: '#ffffff' }} />
                        )}
                    </div>
                  </Col>
                  <Col
                    xs={{
                      span: 19,
                    }}
                    sm={{
                      span: 20,
                    }}
                    md={{
                      span: 21,
                    }}
                    lg={{
                      span: 22,
                    }}
                    xl={{
                      span: 22,
                    }}
                  >
                    <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                      {dataDevice && dataDevice.name ? dataDevice.name : (device || 'Device')}
                    </Row>
                    <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>

                      <Breadcrumb className={styles.date_wrapper}>
                        <Breadcrumb.Item className={styles.breadcrumb}>
                          <Link to="/tablero-general">{BreadcrumbTitle}</Link>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item className={styles.breadcrumb}>
                          <a onClick={handleDeviceHome}>
                            {deviceBusinessType && deviceBusinessType.name || 'Business'}
                          </a>
                        </Breadcrumb.Item>

                        <Breadcrumb.Item className={styles.breadcrumb}>
                          {dataDevice && dataDevice.name || t('menu_items.main.devices')}
                        </Breadcrumb.Item>
                      </Breadcrumb>

                    </Row>
                  </Col>
                </Row>
                <Row>
                  <DeviceData />
                </Row>
              </Card>
            </div>
          </Col>

          <Col
            xs={{
              span: 24,
            }}
            sm={{
              span: 24,
            }}
            md={{
              span: 12,
            }}
            lg={{
              span: 12,
            }}
            xl={{
              span: 12,
            }}
          >
            <div style={{
              height: '100%',
            }}
            >
              <Card className="card_map shadows" style={{ height: '100%', width: '100%' }}>
                <MapForVehicles />
              </Card>
            </div>
          </Col>
        </Row>

        <div className={styles.wrapperBreadcrumbVariable} />

          <Card className="shadows filter-device-detail" style={{ width: '100%', marginTop: '1rem' }}>

          <Row gutter={[16, 8]}>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 12,
              }}
              md={{
                span: 12,
              }}
              lg={{
                span: 8,
              }}
              xl={{
                span: 8,
              }}
            >
              <Select className={styles.select_attribute} value={deviceField} onChange={setDeviceField} dropdownStyle={{ minWidth: '25%' }} disabled={loading}>
                {
                  deviceType.length
                    ? deviceType.map((item, index) => (
                      <Option key={`${item.id}_${index}`} value={item.id}>{item.name}</Option>
                    ))
                    : null
                }
              </Select>
            </Col>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 12,
              }}
              md={{
                span: 12,
              }}
              lg={{
                span: 8,
              }}
              xl={{
                span: 8,
              }}
            >
              <div className={styles.header_datepicker}>
                {/*<Button className={styles.btnPre} onClick={() => changeDate(-1)} disabled={loading}>{'<'}</Button>*/}
                {/*<DatePicker className={styles.btnCenter} value={datePicker} format={modePickerFormat} onChange={setDatePicker} picker={modePicker} disabled={loading} />*/}
                <RangePicker className={styles.btnCenter} value={datePicker} onChange={setDatePicker} format={modePickerFormat} picker={modePicker?modePicker:'day'} />
                {/*<Button className={styles.btnNext} onClick={() => changeDate(1)} disabled={loading}>{'>'}</Button>*/}
              </div>
            </Col>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 12,
              }}
              md={{
                span: 12,
              }}
              lg={{
                span: 8,
              }}
              xl={{
                span: 8,
              }}
            >
             <Select className={styles.select_attribute} value={defaultGranularity} onChange={changeModePicker} disabled={loading} >
                {granularityNew.map((dat, index) => <Option key={`${dat.value}_${index}`} value={dat.value}>{dat.name}</Option>)}
              </Select>
            </Col>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 24,
              }}
              xl={{
                span: 24,
              }}
            >
               <div style={{ width: '100%' }}>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Seleecione" 
                  disabled={loading}
                  options={optionVariableField}
                  value={variableField}
                  onChange={setVariableField}
                />
              </div>
            </Col>
          </Row>
            </Card> 

        <div className={styles.wrapper}>
          <div className={styles.column}>
            <div className={styles.rowHeader}>
              <ConsultGraphArea 
                deviceFieldPred={deviceField} 
                datePickerPred={datePicker} 
                modePickerFormatPred={modePickerFormat} 
                modePickerPred={modePicker} 
                defaultGranularityPred={defaultGranularity} 
            variableFieldPred={variableField} />
            </div>
            <div className={styles.rowHeader}>
             <ConsultGraphColumn 
                deviceFieldPred={deviceField} 
                datePickerPred={datePicker} 
                modePickerFormatPred={modePickerFormat} 
                modePickerPred={modePicker} 
                defaultGranularityPred={defaultGranularity} 
                variableFieldPred={variableField} />
            </div>
          </div> 
          <div className={styles.column}>
            <div className={styles.rowHeader}>
            <ConsultGraphLine 
                deviceFieldPred={deviceField}
                datePickerPred={datePicker}
                modePickerFormatPred={modePickerFormat} 
                modePickerPred={modePicker} 
                defaultGranularityPred={defaultGranularity}
                variableFieldPred={variableField} /> 
             
            </div>
            <div className={styles.rowHeader}>
             <ConsultGraphColumnGrouped 
                deviceFieldPred={deviceField} 
                datePickerPred={datePicker} 
                modePickerFormatPred={modePickerFormat} 
                modePickerPred={modePicker} 
                defaultGranularityPred={defaultGranularity} 
                variableFieldPred={variableField} />
            </div>
          </div>
          <div className={styles.column}>
             <ConsultGraphColumnDiff/>
          </div>
        </div>

      </MainLayout>
    </>
  );

}

export default GraficasDispositivoVariable;
